import Layout from '@/layout'
const taoRouter = [
    {
        path: '/home',
        component: () => import('@/layout/'),
        name: 'home',
        meta: { title: '总览', hasChildrenMenu: true },
        children: [
            {
                path: 'homeIndex',
                name: 'homeIndex',
                component: () => import('@/layout/catchContent/'),
                redirect: '/home/homeIndex/homeIndexOverview',
                meta: {
                    title: '渠道总览',
                    icon: 'icondaohangicon',
                    activeMenu: '/home/homeIndex'
                },
                children: [
                    {
                        path: 'homeIndexOverview',
                        name: 'homeIndexOverview',
                        hidden: true,
                        component: () => import('@/pages/home/index/homeIndex/'),
                        meta: { title: '渠道总览', },
                    },
                ]
            },
            //   商品总览
            {
                path: 'goodshome',
                name: 'goodshome',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '商品总览',
                    icon: 'iconshangpin2',
                    activeMenu: '/home/goodshome'
                },
                redirect: '/home/goodshome/homeIndex',
                children: [
                    {
                        path: 'homeIndex',
                        name: 'homeIndex',
                        hidden: true,
                        component: () => import('@/pages/through/goodshome/homeIndex/'),
                        meta: { title: '商品总览', },
                    },
                ]
            },

            {
                path: 'throughOverview',
                name: 'throughOverview',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '直通车总览',
                    icon: 'iconzhitongche',
                    colorIcon: '#iconzhitongche',
                    activeMenu: '/home/throughOverview'
                },
                redirect: '/home/throughOverview/homeIndex',
                children: [
                    {
                        path: 'homeIndex',
                        name: 'homeIndex',
                        hidden: true,
                        component: () =>import('@/pages/through/newIndex/mainHome/'),
                        meta: { title: '直通车总览',icon: 'iconalixi',colorIcon: '#iconalixi', },
                    },
                ]
            },
            {
                path: 'cubeOverview',
                name: 'cubeOverview',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '引力魔方总览',
                    icon: 'icona-yinlimofangwanxiangtai',
                    colorIcon: '#icona-yinlimofangwanxiangtai',
                    activeMenu: '/home/cubeOverview'
                },
                redirect: '/home/cubeOverview/homeIndex',
                children: [
                    {
                        path: 'homeIndex',
                        name: 'homeIndex',
                        hidden: true,
                        component: () =>import('@/pages/through/cubeOverview/mainCube/'),
                        meta: { title: '引力魔方总览', },
                    },
                ]
            },
            {
                path: 'dtx',
                name: 'dtx',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '万相台总览',
                    icon: 'icona-yinlimofangwanxiangtai',
                    colorIcon: '#icona-yinlimofangwanxiangtai',
                    activeMenu: '/home/dtx'
                },
                redirect: '/home/dtx/homeIndex',
                children: [
                    {
                        path: 'homeIndex',
                        name: 'homeIndex',
                        hidden: true,
                        component: () =>import('@/pages/through/dtx/mainIndexDtx/'),
                        meta: { title: '万相台', },
                    },
                ]
            },
            {
                path: 'recommendRillHistoryOverview',
                name: 'recommendRillHistoryOverview',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '超推钻展历史数据',
                    icon: 'iconzuanzhan',
                    colorIcon: '#iconzuanzhan',
                    activeMenu: '/home/recommendRillHistoryOverview'
                },
                redirect: '/home/recommendRillHistoryOverview/homeIndex',
                children: [
                    {
                        path: 'homeIndex',
                        name: 'homeIndex',
                        hidden: true,
                        component: () =>import('@/pages/through/index/homeRecommendRill/'),
                        meta: { title: '超推钻展历史数据', },
                    },
                ]
            },

            //  分渠道总览
            // {
            //     name: 'minuteHome',
            //     path: 'minuteHome',
            //     component: () => import('@/layout/catchContent/'),
            //     meta: {
            //         title: '分渠道总览',
            //         icon: 'iconfenqudaozonglan',
            //         hasChildrenMenu: true
            //     },
            //     children: [
            //         {
            //             path: 'throughOverview',
            //             name: 'throughOverview',
            //             // hidden: true,
            //             component: () => import('@/pages/through/newIndex/mainHome/'),
            //             props: {
            //                 overviewType: 'subway'
            //             },
            //             meta: { title: '直通车总览' },
            //         },
            //         /*{
            //             path: 'through',
            //             name: 'through',
            //             // hidden: true,
            //             component: () => import('@/pages/through/index/home/'),
            //             props: {
            //                 overviewType: 'subway'
            //             },
            //             meta: {title: '直通车总览（旧）'},

                        
            //         },*/

            //         {
            //             path: 'cubeOverview',
            //             name: 'cubeOverview',
            //             // hidden: true,
            //             component: () => import('@/pages/through/cubeOverview/mainCube/'),
            //             props: {
            //                 overviewType: 'cubeOverview'
            //             },
            //             meta: { title: '引力魔方总览' }
            //         },
            //         {
            //             path: 'recommendRillHistoryOverview',
            //             name: 'recommendRillHistoryOverview',
            //             // hidden: true,
            //             component: () => import('@/pages/through/index/homeRecommendRill/'),
            //             props: {
            //                 overviewType: 'recommendRill'
            //             },
            //             meta: { title: '超推钻展历史数据' }
            //         },


            //         // {
            //         //     path: 'recommendOverview',
            //         //     name: 'recommendOverview',
            //         //     // hidden: true,
            //         //     component: () => import('@/pages/through/index/homeRecommend/'),
            //         //     props: {
            //         //         overviewType: 'recommend'
            //         //     },
            //         //     meta: {title: '超推总览'}
            //         // },
            //         // {
            //         //     path: 'drillOverview',
            //         //     name: 'drillOverview',
            //         //     // hidden: true,
            //         //     component: () => import('@/pages/through/index/homeDiamond/'),
            //         //     props: {
            //         //         overviewType: 'diamond'
            //         //     },
            //         //     meta: {title: '钻展总览'}
            //         // },
            //     ]
            // },

        ],
    },

    {
        path: '/through',
        name: 'through',
        component: () => import('@/layout/'),
        meta: { title: '效果分析', hasChildrenMenu: true },
        redirect: '/through/originalReportForm/aLiAccount/homeMarketingAccount',
        children: [

            // 原始数据报表
            {
                path: 'originalReportForm',
                name: 'originalReportForm',
                component: () => import('@/layout/catchContent/'),
                meta: { title: '报表', icon: 'iconyuanshishujubaobiao', hasChildrenMenu: true },
                children: [
                    {
                        path: 'aLiAccount',
                        name: 'aLiAccount',
                        component: () => import('@/layout/catchContent/'),
                        meta: { title: '阿里系数据', icon: 'iconalixi', colorIcon: '#iconalixi' },
                        children: [
                            {
                                path: 'homeMarketingAccount',
                                name: 'homeMarketingAccount',
                                component: () => import('@/pages/home/marketing/account'),
                                meta: { title: '账户级报表' },
                            },
                            {
                                path: 'keyreport',
                                name: 'keyreport',
                                component: () => import('@/pages/through/marketing/keyreport'),
                                meta: { title: '推广单元报表' },
                            },
                            // {
                            //     path: 'keyword',
                            //     name: 'keyword',
                            //     component: () => import('@/pages/through/marketing/keyword'),
                            //     meta: {title: '关键词报表'},
                            // },
                            {
                                path: 'crowdReport',
                                name: 'crowdReport',
                                component: () => import('@/pages/through/marketing/crowdReport'),
                                meta: { title: '人群表现报表' },
                            },
                            {
                                path: 'creativeReport',
                                name: 'creativeReport',
                                component: () => import('@/pages/through/marketing/creativeReport'),
                                meta: { title: '创意表现报表' },
                            },
                            {
                                path: 'planReport',
                                name: 'planReport',
                                component: () => import('@/pages/through/marketing/planReport'),
                                meta: { title: '计划级报表' },
                            },
                            {
                                path: 'resourceReport',
                                name: 'resourceReport',
                                component: () => import('@/pages/through/marketing/resourceReport'),
                                meta: { title: '资源位报表' },
                            }
                        ]
                    },

                ]
            },
            {
                path: 'helpReport',
                name: 'helpReport',
                component: () => import('@/layout/catchContent/'),
                meta: { title: '自助报表', icon: 'iconyuanshishujubaobiao', hasChildrenMenu: true },
                children: [
                    {
                        path: 'channelCollect',
                        name: 'channelCollect',
                        component: () => import('@/pages/through/helpReport/channelCollect'),
                        meta: { title: '全渠道账户投放汇总' },
                    },
                ]
            },

        ]
    },
    {
        path: '/drill',
        name: 'drill',
        component: () => import('@/layout/'),
        // redirect: '/drill/keyWord/quickDelete',
        meta: {
            title: '投放工具',
            hasChildrenMenu: true,
            // activeMenu: '/drill/basicInvestment/keyWord/keyPutin',
        },
        children: [
            //  基础投放

            {
                path: 'keyWord',
                name: 'keyWord',
                // hidden: true,
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '关键词功能',
                    hasChildrenMenu: true,
                    icon: 'iconguanjianci1'
                },
                children: [
                    {
                        path: 'quickDelete',
                        name: 'quickDelete',
                        component: () => import('@/pages/through/putin/quickDelete'),
                        meta: { title: '快捷删词' },
                        // newDevelop: true
                    },
                    // {
                    //     path: 'keyPutin',
                    //     name: 'keyPutin',
                    //     component: () => import('@/pages/through/putin/keyPutin'),
                    //     meta: {title: '关键词投放'},
                    //     newDevelop:true
                    // },
                    // {
                    //     path: 'fastKeyPutins',
                    //     name: 'fastKeyPutins',
                    //     component: () => import('@/pages/through/fastKeyPutin'),
                    //     meta: {title: '测试-关键词投放'},
                    //     newDevelop:true
                    // },
                    {
                        path: 'addWord',
                        name: 'addWord',
                        component: () => import('@/pages/through/putin/addWord'),
                        meta: { title: '一键加词' },
                        // newDevelop:true
                    },
                    {
                        path: 'fastChangePrice',
                        name: 'fastChangePrice',
                        component: () => import('@/pages/through/putin/fastChangePrice'),
                        meta: { title: '快捷改价' },
                    },
                    {
                        path: 'automaticWord',
                        name: 'automaticWord',
                        component: () => import('@/pages/through/putin/automaticWord'),
                        meta: { title: '自动加词' },
                    },
                    {
                        path: 'keyWordsManage',
                        name: 'keyWordsManage',
                        component: () => import('@/pages/through/putin/keyWordsManage'),
                        meta: { title: '关键词标签管理' },
                    }
                ]
            },
            {
                path: 'commodityFunction',
                name: 'commodityFunction',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '商品功能',
                    hasChildrenMenu: true,
                    icon: 'iconshangpin1'
                },
                children: [
                    {
                        path: 'fastKeyPutin',
                        name: 'fastKeyPutin',
                        component: () => import('@/pages/through/fastKeyPutin'),
                        meta: { title: '直通车快捷上品' },
                        // newDevelop:true
                    },
                    {
                        path: 'quickTaste',
                        name: 'quickTaste',
                        component: () => import('@/pages/recommend/automaticPutin/quickTaste/'),
                        meta: { title: '快捷上品' },
                    },
                    // {
                    //     path: 'fastKeyPutin',
                    //     name: 'fastKeyPutin',
                    //     component: () => import('@/pages/through/putin/fastKeyPutin'),
                    //     meta: {title: '直通车快捷上品'},
                    //     newDevelop:true
                    // },
                    // 插件引导页
                    {
                        path: 'pluginAddPro',
                        name: 'pluginAddPro',
                        component: () => import('@/pages/recommend/automaticPutin/pluginAddPro/'),
                        meta: { title: '魔方批量建计划' },
                        // newDevelop:true
                    },
                    {
                        path: 'batchInferior',
                        name: 'batchInferior',
                        component: () => import('@/pages/recommend/automaticPutin/batchInferior/'),
                        meta: { title: '商品投放管理' },
                        // newDevelop:true
                    },
                    {
                        path: 'cubeBatchInferior',
                        name: 'cubeBatchInferior',
                        component: () => import('@/pages/recommend/automaticPutin/cubeBatchInferior/'),
                        meta: { title: '魔方快捷上品' },
                        // newDevelop:true
                    },
                ]
            },
            // {
            //     path: 'creativeManage',
            //     name: 'creativeManage',
            //     component: () => import('@/layout/catchContent/'),
            //     meta: {
            //         title: '创意功能',
            //         hasChildrenMenu: true,
            //         icon: 'iconshangpin1'
            //     },
            //     children: [
            //         // 插件引导页
            //         {
            //             path: 'subwayCreative',
            //             name: 'subwayCreative',
            //             component: () => import('@/pages/recommend/creativeManage/subwayCreative/'),
            //             meta: { title: '魔方批量建计划' },
            //             // newDevelop:true
            //         }
            //     ]
            // },


            {
                path: 'personManage',
                name: 'personManage',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '人群管理',
                    icon: 'iconjihuaguanli',
                    hasChildrenMenu: true,


                },

                children: [

                    {
                        newDevelop: true,
                        path: 'cubePersonManage',
                        name: 'cubePersonManage',
                        component: () => import('@/pages/recommend/personManage/cubePersonManage/'),
                        meta: { title: '魔方人群管理', },

                    },
                    {
                        newDevelop: true,
                        path: 'batchUpCrowd',
                        name: 'batchUpCrowd',
                        component: () => import('@/pages/recommend/personManage/batchUpCrowd/'),
                        meta: { title: '魔方批量上人群', },
                    }
                ]
            },

            {
                name: 'creativityFn',
                path: 'creativityFn',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '创意功能',
                    hasChildrenMenu: true,
                    icon: 'iconchuangyigongneng'
                },
                children: [
                    {
                        path: 'creativityPut',
                        name: 'creativityPut',
                        component: () => import('@/pages/recommend/automaticPutin/creativityPut/'),
                        meta: { title: '创意投放-钻展' },
                        // newDevelop:true
                    },
                    {
                        path: 'creativity',
                        name: 'creativity',
                        component: () => import('@/pages/recommend/automaticPutin/creativity/'),
                        meta: { title: '创意投放-超推' },
                        // newDevelop:true
                    },
                    {
                        path: 'creativityManage',
                        name: 'creativityManage',
                        component: () => import('@/pages/recommend/automaticPutin/creativityManage/'),
                        meta: { title: '创意管理' },
                        // newDevelop:true
                    },
                    {
                        path: 'filterCreativity',
                        name: 'filterCreativity',
                        component: () => import('@/pages/recommend/automaticPutin/filterCreativity/'),
                        meta: { title: '筛选创意' },
                        // newDevelop:true
                    }
                    // creativityManage
                ]
            },
            // {
            //     path: 'tab',
            //     name: 'tab',
            //     component: () => import('@/layout/catchContent/'),
            //     meta: {
            //         title: '标签管理',
            //         hasChildrenMenu: true,
            //         icon: 'iconbiaoqianguanli'
            //     },
            //     children: [
            //         {
            //             path: 'tabIndex',
            //             name: 'tabIndex',
            //             component: () => import('@/pages/home/tab/tabIndex/'),
            //             meta: { title: '关键词标签' },
            //         },
            //     ]
            // },
            {
                path: 'earlyWarning',
                name: 'earlyWarning',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '预警功能',
                    hasChildrenMenu: true,
                    icon: 'iconyujinggongneng'
                },
                children: [
                    {
                        path: 'warning',
                        name: 'warning',
                        component: () => import('@/pages/home/monitor/warning'),
                        meta: { title: '花费预警' },
                    },
                    {
                        path: 'inWarning',
                        name: 'inWarning',
                        component: () => import('@/pages/home/monitor/inWarning'),
                        meta: { title: '库存预警' },
                    }
                ]
            },
            {
                path: 'intellPromotionData',
                name: 'intellPromotionData',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '自动化调价',
                    icon: 'iconrizhijiankong',
                    hasChildrenMenu: true,
                },
                children: [
                    {
                        path: 'carUpdatePrice',
                        name: 'carUpdatePrice',
                        // hidden: true,
                        component: () => import('@/pages/recommend/automaticPutin/carUpdatePrice/'),
                        meta: { title: '直通车调价', },
                    },
                    {
                        path: 'intellPromotion',
                        name: 'intellPromotion',
                        // hidden: true,
                        component: () => import('@/pages/recommend/automaticPutin/intellPromotion/'),
                        meta: {
                            title: '自动化调价',
                            icon: 'launch.png'
                        },
                    },
                ]
            },
            {
                path: 'planManage',
                name: 'planManage',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '预算管理',
                    icon: 'iconjihuaguanli',
                    hasChildrenMenu: true,
                },
                children: [
                    {
                        path: 'batchAdjustment',
                        name: 'batchAdjustment',
                        // hidden: true,
                        component: () => import('@/pages/recommend/batchAdjustment/'),
                        meta: { title: '直通车日限额管理', },
                    },
                    {

                        path: 'cubeBatchAdjustment',
                        name: 'cubeBatchAdjustment',
                        component: () => import('@/pages/recommend/cubeBatchAdjustment/'),
                        meta: { title: '引力魔方日限额管理', },

                    }
                ]
            },
            {
                path: 'cubeAutoPrice',
                name: 'cubeAutoPrice',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '魔方自动化调价',
                    icon: 'iconjihuaguanli',
                    hasChildrenMenu: true,
                },
                children: [
                    {
                        path: 'taskList',
                        name: 'taskList',
                        // hidden: true,
                        component: () => import('@/pages/recommend/cubeAutoPrice/taskList/'),
                        meta: { title: '任务列表' }
                    },
                    {
                        path: 'log',
                        name: 'log',
                        // hidden: true,
                        component: () => import('@/pages/recommend/cubeAutoPrice/log/'),
                        meta: { title: '调价日志' }
                    },
                    {
                        path: 'report',
                        name: 'report',
                        // hidden: true,
                        component: () => import('@/pages/recommend/cubeAutoPrice/report/'),
                        meta: { title: '报告' }
                    }
                ]
            },
        ]
    },
    {
        path: '/recommend',
        name: 'recommend',
        component: () => import('@/layout/'),
        meta: {
            title: '账户日志',
            hasChildrenMenu: true,
            // redirect: '/recommend/homeLog/operatingRecord',
        },
        children: [

            {
                path: 'operatingRecord',
                name: 'operatingRecord',
                component: () => import('@/pages/home/log/operatingRecord/'),
                meta: { title: '操作记录', icon: 'iconrizhijiankong', },
            },
            {
                path: 'homeLogIndex',
                name: 'homeLogIndex',
                component: () => import('@/pages/home/log/logIndex/'),
                meta: { title: '日志监控', icon: 'iconrizhijiankong' },
            },


        ]

    },
    // {
    //     path: '/system',
    //     name: 'system',
    //     parent: true,
    //     component: () => import('@/layout/'),
    //     meta: {
    //         title: '系统设置',
    //         hasChildrenMenu: true
    //     },
    //     children: [
    //         {
    //             path: 'management',
    //             name: 'management',
    //             component: () => import('@/layout/catchContent/'),
    //             meta: {
    //                 title: '系统管理',
    //                 icon: 'iconxitongguanli',
    //                 hasChildrenMenu: true,
    //             },
    //             children: [
    //                 {
    //                     path: 'menuAdmin',
    //                     name: 'menuAdmin',
    //                     component: () => import('@/pages/system/management/menuAdmin'),
    //                     meta: {title: '菜单管理'},
    //                 },
    //                 {
    //                     path: 'userAdmin',
    //                     name: 'userAdmin',
    //                     component: () => import('@/pages/system/management/userAdmin'),
    //                     meta: {title: '用户管理'},
    //                 },
    //                 {
    //                     path: 'roleAdmin',
    //                     name: 'roleAdmin',
    //                     component: () => import('@/pages/system/management/roleAdmin'),
    //                     meta: {title: '角色管理'},
    //                 }
    //             ]
    //         },
    //     ]
    // }
]


export default taoRouter



// WEBPACK FOOTER //
// ./src/router/tao.js